import React, { createContext, useContext, useMemo } from 'react';

const TERM_SETS = {
  'en-AU': {
    training: 'training',
    Training: 'Training',
    match: 'match',
    Match: 'Match',
    practiceMatch: 'practice match',
    PracticeMatch: 'Practice Match',
    squad: 'squad',
    Squad: 'Squad',
    roster: 'squad',
    Roster: 'Squad',
    field: 'pitch',
    Field: 'Pitch',
    todaySession: "Today's Training",
  },
  'en-US': {
    training: 'practice',
    Training: 'Practice',
    match: 'game',
    Match: 'Game',
    practiceMatch: 'scrimmage',
    PracticeMatch: 'Scrimmage',
    squad: 'roster',
    Squad: 'Roster',
    roster: 'roster',
    Roster: 'Roster',
    field: 'field',
    Field: 'Field',
    todaySession: "Today's Practice",
  },
};

export function detectDeviceLocale() {
  const language = typeof navigator !== 'undefined' ? String(navigator.language || '') : '';
  const locale = /^en-US/i.test(language) ? 'en-US' : 'en-AU';
  return {
    locale,
    country: locale === 'en-US' ? 'US' : 'AU',
  };
}

export function termsForLocale(locale) {
  return TERM_SETS[locale] || TERM_SETS['en-AU'];
}

const LocaleContext = createContext({
  locale: 'en-AU',
  country: 'AU',
  terminology: 'auto',
  terms: TERM_SETS['en-AU'],
});

export function LocaleProvider({ locale, country, terminology, children }) {
  const value = useMemo(() => ({
    locale: locale === 'en-US' ? 'en-US' : 'en-AU',
    country: country || (locale === 'en-US' ? 'US' : 'AU'),
    terminology: terminology || 'auto',
    terms: termsForLocale(locale),
  }), [locale, country, terminology]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  return useContext(LocaleContext);
}
